module.exports = __webpack_public_path__ + "img/ic_team_tiktok_white.ed79d9d8.svg";